
import { Component, OnInit } from '@angular/core';
import { DispatchService } from '@app/shared/services/dispatch.service';
import { ChangeDetectorRef } from '@angular/core';
import { RepeatOrderService } from '@app/shared/services/repeat-order.service';
import { OrderDataService } from '@app/shared/services/order-data.service';
import { forkJoin, of } from 'rxjs';

import * as XLSX from 'xlsx';  // Import XLSX for Excel export
import { ActivatedRoute } from '@angular/router';

interface Dispatch {
  _id: string;
  jssfolderno?: number;
  jobType?: number;
  LamType?: string;
  created: string;  // Ensure `created` field is a string for date comparisons
  ticketNo?: number;  // Add ticketNo here if you want to sort by ticket number
  ticketno?: number; //for manual closure 

  active?: boolean;  // <-- Add this line to define the 'active' property(for save button )
  manualStatus?: string;

}

@Component({
  selector: 'app-dispatch-table',
  templateUrl: './dispatch-table.component.html',
  styleUrls: ['./dispatch-table.component.css']
})
export class DispatchTableComponent implements OnInit {
  dispatches: Dispatch[] = [];  // Array to hold the merged dispatch data
  filteredDispatches: Dispatch[] = [];  // Filtered dispatches based on date range
  paginatedDispatches: Dispatch[] = []; // Data shown in the current page

  fromDate: string = '';
  toDate: string = '';
  currentSortColumn: string = '';
  currentSortDirection: 'asc' | 'desc' = 'asc';
  currentPage: number = 1;
  itemsPerPage: number = 10;
  totalPages: number = 0;
  pageNumbers: number[] = [];
  loading: boolean = false; // New loading state
  searchText: any;

  ticketno: string; //for url

  constructor(
    private dispatchService: DispatchService,
    private repeatOrderService: RepeatOrderService,
    private orderDataService: OrderDataService,
    private cdr: ChangeDetectorRef,
     private route: ActivatedRoute,
  ) { }

  ngOnInit(): void {
    // this.loading = true;  // Start loading
    console.log('Initial Dispatch Status:', this.dispatch.manualStatus);

    // Fetch data from all services and merge the results
    forkJoin({
      repeatOrders: this.repeatOrderService.getAllRepeatOrdersDisp(),
      unsavedOrders: this.orderDataService.getAllunsavedOrdersDisp()
    }).subscribe({
      next: (data) => {
        this.dispatches = [
          ...(Array.isArray(data.repeatOrders) ? data.repeatOrders : [data.repeatOrders]),
          ...(Array.isArray(data.unsavedOrders) ? data.unsavedOrders : [data.unsavedOrders])
        ];
        // this.dispatches.sort((a, b) => {
        // //   // Define custom sorting order based on LamType (or another status field)
        //   const statusOrder = {
        //     'Closed': 1,   // Closed orders come first
        //     'Open': 2,     // Open orders come second
        //     'Pending': 3   // Pending orders come last
        //   };
      
        //   const statusA = a.LamType || '';  // Use LamType or modify as needed
        //   const statusB = b.LamType || '';  // Use LamType or modify as needed
      
        //   // Return sorted based on the defined order
        //   return (statusOrder[statusA] || 4) - (statusOrder[statusB] || 4);  // 4 is used for unknown statuses
        // });
         // Then, sort by ticketNo in descending order
        //  this.dispatches.sort((a, b) => {
        //   return Number(b.ticketNo || 0) - Number(a.ticketNo || 0);
        // });
        

        
      // Initialize each dispatch with an active state of false
      this.dispatches = this.dispatches.map(dispatch => ({
        ...dispatch,
        active: false  // Set active flag to false initially
      }));
      
      // DEFAULT SORT BY DATE (LATEST YEAR FIRST)(for latest data fisrt as per craetion date)
this.dispatches.sort((a, b) => {
  const dateA = new Date(a.created || 0).getTime();
  const dateB = new Date(b.created || 0).getTime();
  return dateB - dateA; // latest first (2026 → 2025 → 2024)
});
// 

       // for mainatining pending status in table (by default)
  this.dispatches.forEach(dispatch => {
    dispatch.manualStatus = dispatch.manualStatus || 'Pending'; 
  });
  // 





        this.filteredDispatches = [...this.dispatches];  // Initially show all data

        this.filterDispatches();
      
        console.log('this is filerlist of disapches',this.filteredDispatches); 
        // Trigger change detection if necessary
        // this.cdr.detectChanges();

        this.applyDateFilter();  // Apply any date filter after data is loaded
        this.cdr.detectChanges();

          // Calculate pagination
        this.calculatePagination();
                // this.loadDispatchDetails();
                // this.loading = false;  // Stop loading after data is fetched

 // After data is loaded and filtered, sort the dispatches
//  this.sortDispatchesByStatus(); // Sort based on order status
//  this.calculatePagination();

      },
      error: (err) => {
        console.error('Error fetching data', err);
        // this.loading = false;  // Stop loading if error occurs

      }
      
    });

     // Fetch all manual closures when the component initializes
     this.loadAllManualClosures();

      // Get the ticketno from the route parameters
    this.route.params.subscribe(params => {
      this.ticketno = params['ticketno'];
      console.log('Ticket Number:', this.ticketno);

      // Now you can use the ticketno to load specific data for this ticket
      // this.loadDispatchDataByTicketno();
    });
  }

  loadAllManualClosures(): void {
    this.dispatchService.getAllManualClosures().subscribe(
      (manualClosures) => {
        // If records are successfully fetched, store them in the component state
        console.log('Loaded manual closures:', manualClosures);
        this.manualClosures = manualClosures;

        this.filterDispatches();
      },
      (error) => {
        // If there's an error fetching the records, log it
        console.error('Error loading manual closures:', error);
      }
    );
  }
  manualClosures: any[] = [];  // Store the fetched manual closure records
 
// Filter dispatches to match with manual closures
// filterDispatches(): void {
//   console.log('Dispatches:', this.dispatches);  // Log all dispatch records
//   console.log('Manual Closures:', this.manualClosures);  // Log all manual closures

//   // Filter dispatches whose ticketno exists in manualClosures
//   this.fetchDispatches = this.dispatches.filter(dispatch => {
//     const matchFound = this.manualClosures.some(closure => closure.ticketno === dispatch.ticketno);  // Use ticketno for both
//     if (matchFound) {
//       // Log only dispatches where ticketno matches a manual closure
//       console.log(`Match found for ticketno: ${dispatch.ticketno} in Dispatch and Manual Closure`);
//     }
//     return matchFound;
//   });

//   // Log filtered dispatches
//   console.log('Filtered Dispatches (fetchDispatches):', this.fetchDispatches);
// }
filterDispatches(): void {
  console.log('Dispatches:', this.dispatches);  // Log all dispatch records
  console.log('Manual Closures:', this.manualClosures);  // Log all manual closures

  // Filter dispatches whose ticketno exists in manualClosures
  this.fetchDispatches = this.dispatches.filter(dispatch => {
    const matchFound = this.manualClosures.some(closure => closure.ticketno === dispatch.ticketno);  // Use ticketno for both
    if (matchFound) {
      // Log only dispatches where ticketno matches a manual closure
      console.log(`Match found for ticketno: ${dispatch.ticketno} in Dispatch and Manual Closure`);
    }
    return matchFound;
  });

  // After filtering, assign manualStatus from manualClosures to each dispatch
  this.fetchDispatches.forEach(dispatch => {
    const matchingClosure = this.manualClosures.find(closure => closure.ticketno === dispatch.ticketno);
    if (matchingClosure) {
      // Assuming `manualStatus` exists in `manualClosures`
      dispatch.manualStatus = matchingClosure.manualStatus;  // or any other field you need to fetch from `manualClosures`
      console.log(`Assigned manualStatus: ${matchingClosure.manualStatus} to dispatch with ticketno: ${dispatch.ticketno}`);
    }
  });

  // Log filtered dispatches with manualStatus
  console.log('Filtered Dispatches with manualStatus (fetchDispatches):', this.fetchDispatches);
}


  getStartIndex(): number {
    return (this.currentPage - 1) * this.itemsPerPage;
  }

  getEndIndex(): number {
    const endIndex = this.currentPage * this.itemsPerPage;
    return endIndex > this.filteredDispatches.length ? this.filteredDispatches.length : endIndex;
  }

  getCurrentPageData(): Dispatch[] {
    return this.filteredDispatches.slice(this.getStartIndex(), this.getEndIndex());
  }

  // Change page handler
  changePage(page: number): void {
    if (page < 1 || page > this.totalPages) return;
    this.currentPage = page;
  }

  // Method to calculate pagination
  calculatePagination(): void {
    this.totalPages = Math.ceil(this.filteredDispatches.length / this.itemsPerPage);
    this.pageNumbers = Array.from({ length: this.totalPages }, (_, i) => i + 1);
  }







  fetchDispatches: any[] = [];    // Store filtered dispatches (formerly filteredDispatches)
 
  onSearch(): void {
    const searchTerm = this.searchText.toLowerCase();
  
    // Type assertion to Dispatch type if necessary
    this.filteredDispatches = this.dispatches.filter((dispatch: any) =>
      dispatch.clientName?.toLowerCase().includes(searchTerm) ||
      dispatch.ticketno?.toLowerCase().includes(searchTerm) ||
      dispatch.jobName?.toLowerCase().includes(searchTerm) ||
      (dispatch.refNo && dispatch.refNo.toLowerCase().includes(searchTerm))
    );
  }
  
  

  
  // Apply date filter
  applyDateFilter(): void {
    const from = this.fromDate ? new Date(this.fromDate) : null;
    const to = this.toDate ? new Date(this.toDate) : null;

    this.filteredDispatches = this.dispatches.filter(dispatch => {
      const dispatchDate = new Date(dispatch.created);
      const isAfterFromDate = from ? dispatchDate >= from : true;
      const isBeforeToDate = to ? dispatchDate <= to : true;
      return isAfterFromDate && isBeforeToDate;
    });
  this.calculatePagination();
    // this.calculatePagination(); // Recalculate pagination after filtering
  }
  // Sort the table by column
    // Sort the table by column
    sortTable(column: string): void {
      const direction = this.currentSortColumn === column && this.currentSortDirection === 'asc' ? 'desc' : 'asc';
      this.currentSortColumn = column;
      this.currentSortDirection = direction;
  
      this.filteredDispatches.sort((a, b) => {
        const aVal = a[column];
        const bVal = b[column];
        if (aVal < bVal) return direction === 'asc' ? -1 : 1;
        if (aVal > bVal) return direction === 'asc' ? 1 : -1;
        return 0;
      });
  
      // this.calculatePagination(); // Recalculate pagination after sorting
    }

  exportToExcel() {
    const ws: XLSX.WorkSheet = XLSX.utils.json_to_sheet(this.filteredDispatches);
    const wb: XLSX.WorkBook = XLSX.utils.book_new();
    XLSX.utils.book_append_sheet(wb, ws, 'Dispatches');
    XLSX.writeFile(wb, 'dispatches_report.xlsx');
  }

  getNumber(value: any): number {
    if (!value) return 0;
    const num = parseFloat(value.toString().replace(/[^\d.-]/g, ''));
    return isNaN(num) ? 0 : num;
  }

  // updateStatusManually(dispatch: any) {
  //   if (dispatch.manualStatus === 'Closed Manually') {
  //     const updateData = {
  //       LamType: 'Closed Manually',
  //       closedNote: `Closed manually by user on ${new Date().toLocaleString()}`
  //     };
  
  //     this.dispatchService.updateManualStatus(dispatch._id, updateData)
  //       .subscribe({
  //         next: (res) => {
  //           console.log('Manual status updated:', res);
  //           dispatch.LamType = 'Closed Manually';
  //           dispatch.closedNote = updateData.closedNote;
  //           dispatch.manualStatus = '';
  //         },
  //         error: (err) => {
  //           console.error('Error updating manual status:', err);
  //           alert('Failed to update status. Please try again.');
  //         }
  //       });
  //   }
  // }
 

    // Method to show confirmation and save the data
    confirmSave(dispatch: any): void {
      if (window.confirm('Do you want to save changes for this dispatch?')) {
        this.saveDispatch(dispatch);
      }
    }
  
    // Method to save the dispatch data via the service
  //   saveDispatch(dispatch: any): void {
  //     const newDispatchData = {
  //       dispatched: dispatch.totalDispatched,
  //       kgsBal: dispatch.kgsBal,
  //       status: dispatch.status,
  //       ticketno: dispatch.ticketno,
  //       refNo: dispatch.refNo,
  //       poNo: dispatch.poNo,
  //       clientName: dispatch.clientName,
  //       jobName: dispatch.jobName,

  //       orderKgs: dispatch.orderKgs,  // New field for orderKgs
  //       orderPcs: dispatch.orderPcs,  // New field for orderPcs
  //       jssfolderno: dispatch.jssfolderno || 0,  // Default to 0 if not present
  //       jobType: dispatch.jobType || 0,  // Default to 0 if not present
  //       LamType: dispatch.LamType || 'Pending',  // Default to 'Pending' if not present
  //       manualStatus: dispatch.manualStatus // No fallback, will be undefined if not selected
  //     };

  //     // If manualStatus is not selected, show an alert or handle as needed
  // if (!newDispatchData.manualStatus) {
  //   alert('Please select a Manual Status.');
  //   return;
  // }
    
  //     this.dispatchService.saveDispatch(newDispatchData).subscribe({
  //       next: (response) => {
  //         alert('Data saved successfully!');
  //         console.log('Saved data:', response);
  //         // Optionally reload the list or do other actions here
  //       },
  //       error: (err) => {
  //         alert('Error saving data!');
  //         console.error('Error saving dispatch:', err);
  //       }
  //     });
  //   }

  // with both add and update 
  saveDispatch(dispatch: any): void {
    const newDispatchData = {
      dispatched: dispatch.totalDispatched,
      kgsBal: dispatch.kgsBal,
      status: dispatch.status,
      ticketno: dispatch.ticketno,
      refNo: dispatch.refNo,
      poNo: dispatch.poNo,
      clientName: dispatch.clientName,
      jobName: dispatch.jobName,
      orderKgs: dispatch.orderKgs,  // New field for orderKgs
      orderPcs: dispatch.orderPcs,  // New field for orderPcs
      jssfolderno: dispatch.jssfolderno || 0,  // Default to 0 if not present
      jobType: dispatch.jobType || 0,  // Default to 0 if not present
      LamType: dispatch.LamType || 'Pending',  // Default to 'Pending' if not present
      manualStatus: dispatch.manualStatus // No fallback, will be undefined if not selected
    };
  
    // If manualStatus is not selected, show an alert or handle as needed
    if (!newDispatchData.manualStatus) {
      alert('Please select a Manual Status.');
      return;
    }
  
    // Call the API to save or update the dispatch (manual closure)
    this.dispatchService.saveDispatch(newDispatchData).subscribe({
      next: (response) => {
        alert('Data saved successfully!');
        console.log('Saved data:', response);
        // Optionally reload the list or do other actions here
           // After saving, reload the dispatch list to reflect the latest data
           this.refreshPage();  // Reload the dispatches
      },
      error: (err) => {
        alert('Error saving data!');
        console.error('Error saving dispatch:', err);
      }
    });
  }
  

  onManualStatusChange(selectedValue: string): void {
  console.log('Selected Manual Status:', selectedValue);  // Log when selection changes
  this.dispatch.manualStatus = selectedValue;  // Ensure value is updated
}
  // dispatch = { manualStatus: '' };
  dispatch = {
    manualStatus: 'Pending'  // Set "Pending" as the default value
  };

  
  
    

  refreshPage(): void {
      window.location.reload();
    }

    setActiveRow(dispatch: Dispatch): void {
      // Reset all dispatches to inactive first
      this.dispatches.forEach(d => d.active = false);
      
      // Activate the clicked row
      dispatch.active = true;
    }
    
  


  
}


 // Modify the applyDateFilter() method to sort after applying the date filter
// applyDateFilter() {
//   if (!this.fromDate && !this.toDate) {
//     this.filteredDispatches = [...this.dispatches];  // Show all data if no filter is applied
//   } else {
//     const from = this.fromDate ? new Date(this.fromDate) : null;
//     const to = this.toDate ? new Date(this.toDate) : null;

//     this.filteredDispatches = this.dispatches.filter(dispatch => {
//       const dispatchDate = new Date(dispatch.created);

//       // Check if the dispatch date is within the range
//       const isAfterFromDate = from ? dispatchDate >= from : true;
//       const isBeforeToDate = to ? dispatchDate <= to : true;

//       return isAfterFromDate && isBeforeToDate;
//     });
//   }

//   // After filtering by date, sort based on status
//   this.sortDispatchesByStatus();  // Apply the sorting again after filtering
// }


//   sortTable(column: string) {
//     const direction = this.currentSortColumn === column && this.currentSortDirection === 'asc' ? 'desc' : 'asc';
//     this.currentSortColumn = column;
//     this.currentSortDirection = direction;

//     this.filteredDispatches.sort((a, b) => {
//       const aVal = a[column];
//       const bVal = b[column];
//       if (aVal < bVal) return direction === 'asc' ? -1 : 1;
//       if (aVal > bVal) return direction === 'asc' ? 1 : -1;
//       return 0;
//     });
//   }

// import { Component, OnInit } from '@angular/core';
// import { DispatchService } from '@app/shared/services/dispatch.service';
// import { ChangeDetectorRef } from '@angular/core';
// import { RepeatOrderService } from '@app/shared/services/repeat-order.service';
// import { OrderDataService } from '@app/shared/services/order-data.service';
// import { forkJoin, of } from 'rxjs';
// import { switchMap, catchError } from 'rxjs/operators';

// interface Dispatch {
//   _id: string;
//   totalDispatched?: number;
//   kgsBal?: number;
//   status?: string;
// }

// interface DispatchStatus {
//   dispatched: number;
//   kgsBal: number;
//   status: string;
// }

// @Component({
//   selector: 'app-dispatch-table',
//   templateUrl: './dispatch-table.component.html',
//   styleUrls: ['./dispatch-table.component.css']
// })
// export class DispatchTableComponent implements OnInit {
//   dispatches: any[] = [];  // Array to hold the merged dispatch data

//   constructor(
//     private dispatchService: DispatchService,
//     private repeatOrderService: RepeatOrderService,
//     private orderDataService: OrderDataService,
//     private cdr: ChangeDetectorRef
//   ) { }

//   ngOnInit(): void {
//     // Fetch data from all services and merge the results
//     forkJoin({
//       repeatOrders: this.repeatOrderService.getAllRepeatOrder(),
//       unsavedOrders: this.orderDataService.getAllUnsavedOrders()
//     }).pipe(
//       switchMap((data) => {
//         this.dispatches = [
//           ...(Array.isArray(data.repeatOrders) ? data.repeatOrders : [data.repeatOrders]),
//           ...(Array.isArray(data.unsavedOrders) ? data.unsavedOrders : [data.unsavedOrders])
//         ];
        
//         // Log the dispatches to check if they have valid IDs
//         console.log("Dispatches to fetch details for:", this.dispatches);
//     // Trigger change detection if necessary
//     this.cdr.detectChanges();
//         // Now for each dispatch, make a call to fetch its dispatch details
//         const dispatchDetailsCalls = this.dispatches.map((dispatch) => 
//           this.dispatchService.getDispatchBydispatchId(dispatch._id).pipe(
//             catchError((error) => {
//               console.error('Error fetching dispatch for ID:', dispatch._id, error);
//               return of(null);  // Handle the error gracefully but log it
//             })
//           )
//         );
        
//         // Wait for all dispatch detail calls to complete
//         return forkJoin(dispatchDetailsCalls);
//       })
//     ).subscribe({
//       next: (dispatchDetails) => {
//         console.log('Dispatch Details:', dispatchDetails);  // Log the data for inspection
//         dispatchDetails.forEach((statusData, index) => {
//           if (statusData) {
//             // Update each dispatch with fetched details
//             this.dispatches[index].totalDispatched = statusData.dispatched;
//             this.dispatches[index].kgsBal = statusData.kgsBal;
//             this.dispatches[index].status = statusData.status;
//           }
//         });

//         // Trigger change detection if necessary
//         this.cdr.detectChanges();
//       },
//       error: (err) => {
//         console.error('Error fetching data', err);
//       }
//     });
//   }
// }
// import { Component, OnInit } from '@angular/core';
// import { DispatchService } from '@app/shared/services/dispatch.service';
// import { ChangeDetectorRef } from '@angular/core';
// import { RepeatOrderService } from '@app/shared/services/repeat-order.service';
// import { OrderDataService } from '@app/shared/services/order-data.service';
// import { forkJoin, of } from 'rxjs';
// import { catchError, switchMap } from 'rxjs/operators';

// interface Dispatch {
//   _id: string;
//   totalDispatched?: number;
//   kgsBal?: number;
//   status?: string;
// }



// @Component({
//   selector: 'app-dispatch-table',
//   templateUrl: './dispatch-table.component.html',
//   styleUrls: ['./dispatch-table.component.css']
// })
// export class DispatchTableComponent implements OnInit {
//   dispatches: Dispatch[] = [];  // Array to hold the merged dispatch data

//   constructor(
//     private dispatchService: DispatchService,
//     private repeatOrderService: RepeatOrderService,
//     private orderDataService: OrderDataService,
//     private cdr: ChangeDetectorRef
//   ) { }

//   ngOnInit(): void {
//     // Fetch data from all services and merge the results
//     forkJoin({
//       repeatOrders: this.repeatOrderService.getAllRepeatOrder(),
//       unsavedOrders: this.orderDataService.getAllUnsavedOrders()
//     }).pipe(
//       switchMap((data) => {
//         // Merge both repeat orders and unsaved orders into a single array
//         this.dispatches = [
//           ...(Array.isArray(data.repeatOrders) ? data.repeatOrders : [data.repeatOrders]),
//           ...(Array.isArray(data.unsavedOrders) ? data.unsavedOrders : [data.unsavedOrders])
//         ];

//         console.log("Dispatches to fetch details for:", this.dispatches);
//         // Trigger change detection if necessary
//         this.cdr.detectChanges();

//         // Now for each dispatch, fetch its dispatch details using the getDispatchBydispatchId method
//         const dispatchDetailsCalls = this.dispatches.map((dispatch) => 
//           this.dispatchService.getDispatchBydispatchId(dispatch._id).pipe(
//             catchError((error) => {
//               console.error('Error fetching dispatch for ID:', dispatch._id, error);
//               return of(null);  // Handle the error gracefully but log it
//             })
//           )
//         );

//         // Wait for all dispatch detail calls to complete using forkJoin
//         return forkJoin(dispatchDetailsCalls);
//       })
//     ).subscribe({
//       next: (dispatchDetails) => {
//         console.log('Dispatch Details:', dispatchDetails);  // Log the data for inspection
        
//         // Update the dispatch array with the fetched details
//         // Update the dispatch array with the fetched details
//         dispatchDetails.forEach((statusData, index) => {
//           if (statusData) {
//             this.dispatches[index].totalDispatched = statusData.dispatched;
//             this.dispatches[index].kgsBal = statusData.kgsBal;
//             this.dispatches[index].status = statusData.status;
//           }
//         });

//         // Trigger change detection to update the view
//         this.cdr.detectChanges();
//       },
//       error: (err) => {
//         console.error('Error fetching data', err);
//       }
//     });
//   }
// }

 // Function to sort dispatches by their status
// sortDispatchesByStatus() {
//   this.filteredDispatches.sort((a, b) => {
//     // Define custom sorting order based on LamType (or another status field)
//     const statusOrder = {
//       'Closed': 1,   // Closed orders come first
//       'Open': 2,     // Open orders come second
//       'Pending': 3   // Pending orders come last
//     };

//     const statusA = a.LamType || '';  // Use LamType or modify as needed
//     const statusB = b.LamType || '';  // Use LamType or modify as needed

//     // Return sorted based on the defined order
//     return (statusOrder[statusA] || 4) - (statusOrder[statusB] || 4);  // 4 is used for unknown statuses
//   });
// }
// Function to load dispatch details for each order
// loadDispatchDetails() {
//   const dispatchDetailsCalls = this.dispatches.map((dispatch) =>
//     this.dispatchService.getDispatchBydispatchId(dispatch._id).pipe(
//       catchError((error) => {
//         console.error('Error fetching dispatch for ID:', dispatch._id, error);
//         return of(null);  // Return null if there's an error
//       }),
//       switchMap((dispatchStatus) => {
//         // Check if a dispatchStatus was returned
//         if (dispatchStatus) {
//           // Only update the dispatch if a valid dispatchStatus is returned
//           dispatch.jssfolderno = dispatchStatus.dispatched;
//           dispatch.jobType = dispatchStatus.kgsBal;
//           dispatch.LamType = dispatchStatus.status;
//           console.log(`Dispatch ID ${dispatch._id} updated with new status.`);
//         } else {
//           // If dispatchStatus is null, leave the dispatch as is (don't change its status)
//           console.log(`Dispatch ID ${dispatch._id} not found or has no status. Keeping original status.`);
//         }
//         return of(dispatch);  // Return updated or unchanged dispatch
//       })
//     )
//   );

//   // Use forkJoin to run all the dispatch API calls in parallel
//   forkJoin(dispatchDetailsCalls).subscribe({
//     next: (updatedDispatches) => {
//       // After updating dispatches with the latest status, update the filtered list
//       this.filteredDispatches = updatedDispatches;
//       console.log('Updated dispatches with dispatch details:', this.filteredDispatches);
//       this.applyDateFilter();  // Apply any date filtering logic
//       this.cdr.detectChanges();  // Trigger change detection to update the view
//     },
//     error: (err) => {
//       console.error('Error fetching dispatch details:', err);
//     }
//   });

// }
   // Calculate pagination
  //  calculatePagination(): void {
  //   this.totalPages = Math.ceil(this.filteredDispatches.length / this.itemsPerPage);

  //   // Show a subset of pages (5 pages at a time)
  //   let startPage = Math.floor((this.currentPage - 1) / 5) * 5 + 1;
  //   let endPage = Math.min(startPage + 4, this.totalPages);

  //   this.pageNumbers = [];
  //   for (let i = startPage; i <= endPage; i++) {
  //     this.pageNumbers.push(i);
  //   }

  //   this.updatePaginatedDispatches();
  // }

  // Update the dispatch data for the current page
  // updatePaginatedDispatches(): void {
  //    // Sort the dispatches by ticketNo (or jssfolderno if necessary) in descending order
  //   //  this.filteredDispatches.sort((a, b) => {
  //   //   return b.ticketNo - a.ticketNo;  // Sort by ticketNo (descending)
  //   // });
  //   const startIndex = (this.currentPage - 1) * this.itemsPerPage;
  //   const endIndex = startIndex + this.itemsPerPage;
  //   this.paginatedDispatches = this.filteredDispatches.slice(startIndex, endIndex);
     
  // }

   // Change to a new page
  //  changePage(page: number): void {
  //   if (page < 1 || page > this.totalPages) return;
  //   this.currentPage = page;
  //   this.calculatePagination(); // Recalculate pagination when the page changes
  // }
